import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { useFormatMessage } from 'src/providers/intl'
import { isTouchDevice } from 'src/helpers/browser'
import { QUESTIONS } from 'src/constants/messages'
import {
  selectCustomerFirstName,
  selectCustomerPhone,
  selectCorporateProfile,
} from 'src/store/selectors/customerProfile'
import {
  selectContactFirstName,
  selectContactPhone,
} from 'src/store/selectors/contact'
import { If, Button, Avatar } from 'src/Components'
import { IconPhone } from 'src/Components/shared/Icon'
import Questions from 'src/Components/shared/Questions/QuestionsContainer'

import styles from './OverlayFooters.module.scss'

const messageShape = PropTypes.shape({
  id: PropTypes.string,
  defaultMessage: PropTypes.string,
})

const propTypes = {
  topic: PropTypes.oneOfType([PropTypes.string, messageShape, PropTypes.any]),
  topicKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  questions: PropTypes.arrayOf(messageShape),
  placeholder: PropTypes.oneOfType([PropTypes.bool, messageShape]),
  disableCospo: PropTypes.bool,
  renderHeader: PropTypes.func,
  id: PropTypes.string,
}

const OverlayQuestionsFooter = ({
  topic,
  topicKey,
  questions,
  placeholder,
  disableCospo,
  renderHeader,
  id,
}) => {
  const intlFormat = useFormatMessage()

  const contactFirstName = useSelector(selectContactFirstName)
  const contactPhone = useSelector(selectContactPhone)
  const customerFirstName = useSelector(selectCustomerFirstName)
  const customerPhone = useSelector(selectCustomerPhone)
  const corporateProfile = useSelector(selectCorporateProfile) || {}

  const { avatarUri: companyLogo } = corporateProfile

  const name = disableCospo ? customerFirstName : contactFirstName
  const phone = disableCospo ? customerPhone : contactPhone

  let formattedTopic
  if (Array.isArray(topic)) {
    formattedTopic = topic.map(t =>
      typeof t === 'object' && t !== null ? intlFormat(t) : t
    )
  } else {
    formattedTopic =
      typeof topic === 'object' && topic !== null ? intlFormat(topic) : topic
  }

  let formattedQuestions = []
  if (questions && questions.length) {
    const result = questions.reduce((list, question) => {
      list.push({
        question: intlFormat(question),
      })
      return list
    }, [])
    formattedQuestions = result
  }
  if (placeholder || !questions) {
    formattedQuestions.push({
      placeholder: intlFormat(
        typeof placeholder === 'object' ? placeholder : QUESTIONS.placeholder
      ),
    })
  }

  return (
    <div className={styles.footer} id={id}>
      <div className={styles.topDecoration}>
        {companyLogo && (
          <Avatar className={styles.companyAvatar} src={companyLogo} />
        )}
      </div>
      <Questions
        location='Overlay'
        questionTopic={formattedTopic}
        questionTopicKey={topicKey}
        questions={formattedQuestions}
        disableCospo={disableCospo}
        renderHeader={renderHeader}
      />
    </div>
  )
}

OverlayQuestionsFooter.defaultProps = {
  topic: 'HomeownerHelp',
}
OverlayQuestionsFooter.propTypes = propTypes

export default OverlayQuestionsFooter
